import styled from 'styled-components/macro';
import { getItemAnimation } from 'styles/animations.styled';

export const Wrapper = styled.div<{
  isSelected: boolean;
  isCollapsed: boolean;
}>`
  display: ${(props) =>
    props.isCollapsed && !props.isSelected ? 'none' : 'block'};
  animation-name: ${(props) => getItemAnimation(props.isCollapsed)};
  animation-delay: 0s;
  animation-duration: 300ms;
  transition: 150ms all;
`;

export const ContactsWrapper = styled.div<{
  isSelected: boolean;
  isCollapsed: boolean;
}>`
  display: ${(props) =>
    props.isCollapsed && !props.isSelected ? 'none' : 'flex'};
  animation-name: ${(props) => getItemAnimation(props.isCollapsed)};
  animation-delay: 0s;
  animation-duration: 300ms;
  transition: 150ms all;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid ${(props) => (props.isSelected ? '#697180' : 'transparent')};
  box-shadow: 0 1px 2px 0 rgba(15, 23, 40, 0.04),
    0 1px 3px 0 rgba(15, 23, 40, 0.12), 0 0 8px 4px rgba(15, 23, 40, 0.04);
  flex-direction: column;
`;

export const ContactsLine = styled.div`
  display: flex;
  gap: 8px;

  :not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const StyledSpan = styled.span`
  color: #495466;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: 8px;
`;
